// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scribePlan-modal .close {
  position: absolute;
  top: -14px;
  right: -6px;
  opacity: 1;
  z-index: 1;
}
.scribePlan-modal .close i {
  background: #fff;
  padding: 2px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 14px;
  color: #000;
}
.scribePlan-modal .subscribe-plans {
  position: relative;
}
.scribePlan-modal .subscribe-plans .subscribe-lable {
  position: absolute;
  left: -26px;
  top: 40%;
  transform: rotate(-90deg);
  border-bottom-left-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
  padding: 0.01rem 0.4rem;
  font-size: 12px;
  color: #ffffff;
}
.scribePlan-modal .subscribe-plans .price-block {
  display: block;
  width: 100px;
  height: 80px;
  border-radius: 0.4rem;
}
.scribePlan-modal .subscribe-plans .price-block i {
  font-size: 25px;
}
.scribePlan-modal .subscribe-plans.one-week {
  border-color: #00d490;
}
.scribePlan-modal .subscribe-plans.one-week .plan-description {
  color: #00d490;
}
.scribePlan-modal .subscribe-plans.one-week .subscribe-lable,
.scribePlan-modal .subscribe-plans.one-week .price-block {
  background: #00d490;
}
.scribePlan-modal .subscribe-plans.three-months {
  border-color: #eb7a00;
}
.scribePlan-modal .subscribe-plans.three-months .plan-description {
  color: #eb7a00;
}
.scribePlan-modal .subscribe-plans.three-months .subscribe-lable,
.scribePlan-modal .subscribe-plans.three-months .price-block {
  background: #eb7a00;
}
.scribePlan-modal .subscribe-plans.six-months {
  border-color: #072084;
}
.scribePlan-modal .subscribe-plans.six-months .plan-description {
  color: #072084;
}
.scribePlan-modal .subscribe-plans.six-months .subscribe-lable,
.scribePlan-modal .subscribe-plans.six-months .price-block {
  background: #072084;
}
.scribePlan-modal .subscribe-plans.one-year {
  border-color: #006c81;
}
.scribePlan-modal .subscribe-plans.one-year .plan-description {
  color: #006c81;
}
.scribePlan-modal .subscribe-plans.one-year .subscribe-lable,
.scribePlan-modal .subscribe-plans.one-year .price-block {
  background: #006c81;
}
.scribePlan-modal .subscribe-plans:not(:last-child) {
  margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/home/_subscribe-plans.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AAAR;AAEQ;EACI,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAAZ;AAII;EACI,kBAAA;AAFR;AAIQ;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,yBAAA;EACA,iCAAA;EACA,kCAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAFZ;AAKQ;EACI,cAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;AAHZ;AAKY;EACI,eAAA;AAHhB;AAOQ;EACI,qBAAA;AALZ;AAOY;EACI,cAAA;AALhB;AAQY;;EAEI,mBAAA;AANhB;AAUQ;EACI,qBAAA;AARZ;AAUY;EACI,cAAA;AARhB;AAWY;;EAEI,mBAAA;AAThB;AAaQ;EACI,qBAAA;AAXZ;AAaY;EACI,cAAA;AAXhB;AAcY;;EAEI,mBAAA;AAZhB;AAgBQ;EACI,qBAAA;AAdZ;AAgBY;EACI,cAAA;AAdhB;AAiBY;;EAEI,mBAAA;AAfhB;AAmBQ;EACI,mBAAA;AAjBZ","sourcesContent":[".scribePlan-modal {\n    .close {\n        position: absolute;\n        top: -14px;\n        right: -6px;\n        opacity: 1;\n        z-index: 1;\n\n        i {\n            background: #fff;\n            padding: 2px;\n            border-radius: 50%;\n            width: 20px;\n            height: 20px;\n            font-size: 14px;\n            color: #000;\n        }\n    }\n\n    .subscribe-plans {\n        position: relative;\n\n        .subscribe-lable {\n            position: absolute;\n            left: -26px;\n            top: 40%;\n            transform: rotate(-90deg);\n            border-bottom-left-radius: .2rem;\n            border-bottom-right-radius: 0.2rem;\n            padding: 0.01rem .4rem;\n            font-size: 12px;\n            color: #ffffff;\n        }\n\n        .price-block {\n            display: block;\n            width: 100px;\n            height: 80px;\n            border-radius: .4rem;\n\n            i {\n                font-size: 25px;\n            }\n        }\n\n        &.one-week {\n            border-color: #00d490;\n\n            .plan-description {\n                color: #00d490;\n            }\n\n            .subscribe-lable,\n            .price-block {\n                background: #00d490;\n            }\n        }\n\n        &.three-months {\n            border-color: #eb7a00;\n\n            .plan-description {\n                color: #eb7a00;\n            }\n\n            .subscribe-lable,\n            .price-block {\n                background: #eb7a00;\n            }\n        }\n\n        &.six-months {\n            border-color: #072084;\n\n            .plan-description {\n                color: #072084;\n            }\n\n            .subscribe-lable,\n            .price-block {\n                background: #072084;\n            }\n        }\n\n        &.one-year {\n            border-color: #006c81;\n\n            .plan-description {\n                color: #006c81;\n            }\n\n            .subscribe-lable,\n            .price-block {\n                background: #006c81;\n            }\n        }\n\n        &:not(:last-child) {\n            margin-bottom: 1rem;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
